import { ArrowDownwardTwoTone, ArrowUpwardTwoTone } from "@mui/icons-material";
import { Collapse, Tooltip } from "@mui/material";
import { selectToken, selectUser } from "../../../features/auth/authSlice";
import {
  useCreateFacilityMutation,
  useDeleteFacilityMutation,
  useUpdateFacilityMutation,
} from "../../../features/facility/facilityApiSlice";

import CommunityAddModal from "./components/CommunityAddModal";
import CommunityDeleteModal from "./components/CommunityDeleteModal";
import { FileUploader } from "react-drag-drop-files";
import IconComponent from "../../../components/DataTable/Icon";
import { Icons } from "../../../assets";
import Loading from "../../../components/Loading";
import Pagination from "../../../components/Pagination/Pagination";
import React from "react";
import Search from "../../../components/Search/SearchNew";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import axios from "axios";
import classNames from "classnames";
import { useFetchFacilitiesMutation } from "../../../features/organisation/organisationApiSlice";
import { useLSStore } from "../../../context/ls-store";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useDebounce from "../../../hooks/useDebounce";
import CommunityZoneEditModal from "./components/CommunityZoneEditModal";
import FilterSelect from "../../../components/Filter/FilterSelect";
import ReusableModal from "../../../components/Modals/ReusableModal";

const fileTypes = ["csv", "xls", "xlsx"];

const CommunityList = () => {
  const [communities, setCommunities] = React.useState([]);

  const [searchFilter, setSearchFilter] = React.useState("");

  const [sortNOPOrder, setSortNOPOrder] = React.useState("none");
  const [sortNameOrder, setSortNameOrder] = React.useState("none");
  const [sortNoFOrder, setSortNoFOrder] = React.useState("none");
  const [communityModalOpen, setCommunityModalOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [del, setDel] = React.useState(false);
  const [data, setData] = React.useState({});
  const [openDropdown, setOpenDropdown] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);

  const [zonesModalOpen, setZonesModalOpen] = React.useState(false);
  const [communityZonesData, setCommunityZonesData] = React.useState(null);

  const [zips, setZips] = React.useState([]);
  const [zipFilter, setZipFilter] = React.useState([]);
  const [showZipModal, setShowZipModal] = React.useState({ status: false, zips: [] });

  const [facilityTypes, setFacilityTypes] = React.useState([]);
  const [facilityTypeFilter, setFacilityTypeFilter] = React.useState([]);



  const search = useDebounce(searchFilter, 500);

  const user = useSelector(selectUser);
  const [fetchFacilities, { isLoading: getLoading }] =
  useFetchFacilitiesMutation();
  const [createFacility, { isLoading: createLoading }] =
  useCreateFacilityMutation();
  const [updateFacility, { isLoading: updateLoading }] =
    useUpdateFacilityMutation();
  const [deleteFacility, { isLoading: deleteLoading }] =
    useDeleteFacilityMutation();

  const isLoading =
    getLoading || createLoading || updateLoading || deleteLoading;

  const navigate = useNavigate();

  const handleCommunityClick = (community) => {
    navigate(`/data-management/communities/${community.id}`);
  };

  const getCommunities = async ({ limit, skip }) => {
    try {
      console.log({
        orgId: user.organisation.id,
        limit,
        skip,
        search,
        zips: JSON.stringify(zipFilter || []),
        facilityTypes: JSON.stringify(facilityTypeFilter || [])
      });

      const { data, count, facilitiesTypes } = await fetchFacilities({
        orgId: user.organisation.id,
        limit,
        skip,
        search,
        zips: JSON.stringify(zipFilter || []),
        facilityTypes: JSON.stringify(facilityTypeFilter || [])
      }).unwrap();
      setCommunities(data);
      setCount(count);
      setFacilityTypes((facilitiesTypes ?? [])?.map((type) => type.name));
    } catch (error) {
      console.error(error.data.message);
    }
  };

  const handleSortNOP = (a, b) => {
    if (sortNOPOrder === "none") {
      return 0;
    } else if (sortNOPOrder === "asc") {
      return (a._noOfPatients ?? 0) - (b._noOfPatients ?? 0);
    } else {
      return (b._noOfPatients ?? 0) - (a._noOfPatients ?? 0);
    }
  };

  const handleSortName = (a, b) => {
    if (sortNameOrder === "none") {
      return 0;
    } else if (sortNameOrder === "asc") {
      return a.name.localeCompare(b.name);
    } else {
      return b.name.localeCompare(a.name);
    }
  };

  const handleSortNoF = (a, b) => {
    if (sortNoFOrder === "none") {
      return 0;
    } else if (sortNoFOrder === "asc") {
      return a.noOfFacilities - b.noOfFacilities;
    } else {
      return b.noOfFacilities - a.noOfFacilities;
    }
  };

  React.useEffect(() => {
    getCommunities({ limit: 20, skip: 0 });
  }, [search, zipFilter, facilityTypeFilter]);

  const Avatar = ({ name, image }) => {
    return (
      <>
        {image !== null ? (
          <div className="flex gap-2 items-center">
            <img
              src={image}
              alt={name}
              className="object-cover w-10 h-10 rounded-full"
            />
          </div>
        ) : (
          <p className="flex justify-center items-center m-0 w-10 h-10 text-white rounded-full bg-primaryblue">
            {name
              ?.split(" ")
              ?.map((n) => n[0])
              ?.slice(0, 2)
              ?.map((n) => n?.toUpperCase())
              ?.join("")}
          </p>
        )}
      </>
    );
  };

  const updateCommunityZones = (communityId, zones) => {
    setCommunities((prev) => {
      const updatedCommunities = prev.map((community) =>
        community.id === communityId ? { ...community, zones } : community
      );
      return updatedCommunities;
    });
  };

  const setAlert = useLSStore((state) => state.setAlert);

  const token = useSelector(selectToken);

  async function uploadFile(file) {
    const formData = new FormData();
    formData.append("file", file);

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/community/verify-communities-doc`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": process.env.REACT_APP_SERVER_URL,
          },
          withCredentials: true,
        }
      );

      await getCommunities({ limit: 20, skip: 0 });

      setOpenDropdown(false);

      setAlert({
        message: "Data Uploaded Successfully",
        severity: "success",
      });
    } catch (error) {
      console.log(error);
    }
  }

  const handleChange = (file) => {
    try {
      uploadFile(file);
    } catch (error) {
      console.log("err");
    }
  };

  const saveCommunity = async () => {
    try {
      await createFacility({
        name: data.name,
        street: data.street,
        city: data.city,
        state: data.state,
        zip: data.zip,
        is_referral: data.is_referral,
        type_id: data.type_id,
      }).unwrap();

      getCommunities({ limit: 20, skip: 0 });

    } catch (error) {
      throw new Error(error?.data?.message || error.message);
    }
  };

  React.useEffect(() => {
    setZips(Array.from(
      new Set(
        communities
          .map((community) => community.zips?.map((zip) => zip))
          .flat()
          .filter(Boolean)

      )
    ).filter(Boolean));
  }, [communities]);

  const handleZoneFilter = (zip) => {
    if (zipFilter.indexOf(zip) === -1) {
      setZipFilter([...zipFilter, zip]);
    } else {
      setZipFilter(zipFilter.filter((filter) => filter !== zip));
    }
  };

  const handleFacilityTypeFilter = (facilityType) => {
    if (facilityTypeFilter.indexOf(facilityType) === -1) {
      setFacilityTypeFilter([...facilityTypeFilter, facilityType]);
    } else {
      setFacilityTypeFilter(facilityTypeFilter.filter((filter) => filter !== facilityType));
    }
  };

  const onUpdateCommunity = async () => {
    try {
      const facilityName = data.communityName ?? data.name;
      await updateFacility({
        id: edit,
        name: facilityName,
        street: data.street ?? "",
        city: data.city ?? "",
        state: data.state ?? "",
        zip: data.zip ?? "",
        type: data.facility_type ?? data.type ?? "",
        type_id: data.type_id ?? "",
      }).unwrap();

      await getCommunities({ limit: 20, skip: 0 });
    } catch (error) {
      throw new Error(error?.data?.message || error.message);
    }
  };

  const onDeleteCommunity = async () => {
    try {
      await deleteFacility({
        id: del,
      }).unwrap();

      setCommunities((prev) => {
        const update = [...prev].filter((x) => x.id !== del);
        return [...update];
      });
    } catch (error) {
      setAlert({
        message: error?.data?.message || error.message,
        severity: "error",
      });
    }
  };

  const onEdit = (row) => {
    const [street, city, state, zip] = (row.address || "").split(", ");
    const facilityObj = row._facility && typeof row._facility === "object" ? row._facility : null;
    const isFacilityRow = facilityObj != null && Array.isArray(row._allFacilities) && row._allFacilities.length > 0 && row._editingFacilityIndex != null;
    setData({
      ...row,
      street,
      city,
      state,
      zip,
      name: isFacilityRow ? (facilityObj.name ?? "") : row.name,
      communityName: row.name,
      facility_name: facilityObj?.name ?? "",
      type_id: facilityObj?.type_id ?? row.type_id ?? row.facility_type_id ?? "",
      facility_type: facilityObj?.type ?? row.facility_type ?? "",
      _allFacilities: row._allFacilities ?? [],
      _editingFacilityIndex: row._editingFacilityIndex ?? null,
    });
    setEdit(row.id);
    setCommunityModalOpen(true);
    setDeleteModalOpen(false);
  };

  const onDelete = (location) => {
    setDeleteModalOpen(true);
    setData(location);
    setDel(location.id);
  };

  const handleSelectCommunity = (community) => {
    setZonesModalOpen(true);
    setCommunityZonesData(community);
  };

  const clearInput = () => {
    setData({});
  };

  const downloadCSV = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/community/get/template`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "community-template.csv");
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div className="flex flex-col items-start py-4 overflow-hidden max-h-[calc(100vh-100px)]">
      <ReusableModal
        open={showZipModal?.status}
        title="Coverage"
        onClose={() => {
          setShowZipModal({ status: false, zips: [] })
        }}
      >
        <div className="min-w-[45vw] max-w-[45vw] p-3 ">
          <h2 className="mb-3 text-lg font-semibold">Zip Codes</h2>
          <div
            className="text-gray-700 max-h-[400px] overflow-y-auto p-2 rounded-md border border-gray-200 bg-gray-50"
          >
            {showZipModal?.zips?.length > 0 ? (
              <p className="leading-relaxed whitespace-normal break-words">
                {showZipModal.zips.join(", ")}

              </p>
            ) : (
              <p className="italic text-gray-500">No Zip codes available.</p>
            )}
          </div>
        </div>
      </ReusableModal>
      <Loading loading={isLoading} />
      {user?.permissions?.includes('communities_dm.upload_communities') &&
        <>
          <div
            className={classNames(
              "w-full px-16 transition-all",
              !openDropdown && "pb-8"
            )}
          >
            <button
              onClick={() => {
                setOpenDropdown(!openDropdown);
              }}
              className="flex flex-row justify-between items-center px-4 py-2 w-full bg-gray-100 rounded-md"
            >
              <div className="flex flex-row items-center">
                Upload Community Data
                <img
                  src={Icons.Upload_Icon}
                  alt="upload icon"
                  className="mx-2 icon"
                />
              </div>
              {!openDropdown ? (
                <Tooltip title="Expand">
                  <ArrowDownwardTwoTone />
                </Tooltip>
              ) : (
                <Tooltip title="Collapse">
                  <ArrowUpwardTwoTone />
                </Tooltip>
              )}
            </button>
          </div>
          <Collapse in={openDropdown} className="w-full">
            <div className="flex flex-col gap-1 px-16 py-8 w-full">
              <div className="flex flex-row justify-end items-end mb-2 w-full md:mb-0">
                <p
                  className="m-0 text-sm underline text-primaryblue"
                  onClick={downloadCSV}
                  role="button"
                >
                  Community Data Template
                </p>
              </div>
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
                classes="w-100"
              >
                <div className="flex hover:bg-subtleblue transition-all cursor-pointer flex-col w-full justify-center items-center gap-2 border-[1px] border-dashed border-secondarygrayborder rounded-lg p-4">
                  <img
                    src={Icons.Upload_Icon}
                    alt="upload icon"
                    className="mx-2 icon"
                  />
                  <p className="m-0 mt-2 text-sm">
                    Drag & Drop or{" "}
                    <span className="text-primaryblue">Choose file</span> to upload
                  </p>
                </div>
              </FileUploader>
            </div>
          </Collapse>
        </>}
      <div className="flex flex-row justify-between items-center px-16 w-full">
        <div className="flex flex-row gap-12 items-center w-full">
          <h1 className="m-0 text-2xl font-bold whitespace-nowrap w-fit">
            Communities{" "}
            <span className="ml-2 text-base font-bold text-primaryblue">
              {count}
            </span>
          </h1>
          <div className="flex flex-row gap-8 items-center w-full max-w-7xl">
            {user?.permissions?.includes('communities_dm.search') && <Search value={searchFilter} setValue={setSearchFilter} />}
            {user?.permissions?.includes('communities_dm.filter_zip') && <FilterSelect
              value={zipFilter}
              handleChange={handleZoneFilter}
              data={zips}
              placeholder="Filter by Zip ..."
            />}
            {user?.permissions?.includes('communities_dm.filter_facility_type') && <FilterSelect
              value={facilityTypeFilter}
              handleChange={handleFacilityTypeFilter}
              data={facilityTypes}
              placeholder="Filter by Facility Types ..."
            />}
          </div>
        </div>
        {user?.permissions?.includes('communities_dm.add_community') && <button
          onClick={() => {
            setCommunityModalOpen(true);
            setEdit(false);
          }}
          className="flex justify-center items-center px-4 py-2 text-sm font-bold text-white whitespace-nowrap rounded-lg bg-primaryblue"
        >
          Add Community
        </button>}
      </div>

      <div className="px-16 mt-2 w-full">
        <Pagination count={count} api={getCommunities} />
        <div className="relative w-full  mb-2 overflow-x-auto overflow-y-auto bg-white rounded-lg shadow  max-h-[calc(100vh-300px)]">
          <table className="relative w-full bg-white border-collapse table-auto whitespace-no-wrap table-striped">
            <thead>
              <tr className="h-16 text-base font-bold text-left text-white whitespace-nowrap bg-primaryblue">
                <th className="px-4 py-3">
                  <div className="flex flex-row gap-2 items-center">
                    <p className="m-0">Name</p>
                    <button
                      className="flex flex-col gap-1 items-center"
                      onClick={() => {
                        if (sortNameOrder === "none") {
                          setSortNameOrder("asc");
                        }
                        if (sortNameOrder === "asc") {
                          setSortNameOrder("desc");
                        }
                        if (sortNameOrder === "desc") {
                          setSortNameOrder("none");
                        }
                      }}
                    >
                      {sortNameOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortNameOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        // <div className="flex items-center h-4">
                        //   <div className="w-6 h-[2px] bg-white" />
                        // </div>
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                <th className="px-4 py-3">Address</th>
                <th className="px-4 py-3">Facility Type</th>
                {process.env.REACT_APP_ENV === "dev" && (
                  <th className="px-4 py-3">Coverage</th>
                )}
                <th className="px-4 py-3">
                  <div className="flex flex-row gap-2 items-center">
                    <p className="m-0">No of Patients</p>
                    <button
                      className="flex flex-col gap-1 items-center"
                      onClick={() => {
                        if (sortNOPOrder === "none") {
                          setSortNOPOrder("asc");
                        }
                        if (sortNOPOrder === "asc") {
                          setSortNOPOrder("desc");
                        }
                        if (sortNOPOrder === "desc") {
                          setSortNOPOrder("none");
                        }
                      }}
                    >
                      {sortNOPOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortNOPOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        // <div className="flex items-center h-4">
                        //   <div className="w-6 h-[2px] bg-white" />
                        // </div>
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th>
                {/* <th className="px-4 py-3">
                  <div className="flex flex-row gap-2 items-center">
                    <p className="m-0">No of Facilities</p>
                    <button
                      className="flex flex-col gap-1 items-center"
                      onClick={() => {
                        if (sortNoFOrder === "none") {
                          setSortNoFOrder("asc");
                        }
                        if (sortNoFOrder === "asc") {
                          setSortNoFOrder("desc");
                        }
                        if (sortNoFOrder === "desc") {
                          setSortNoFOrder("none");
                        }
                      }}
                    >
                      {sortNoFOrder === "asc" ? (
                        <Tooltip title="Sort Descending">
                          <ArrowDownwardTwoTone />
                        </Tooltip>
                      ) : sortNoFOrder === "desc" ? (
                        <Tooltip title="Sort Ascending">
                          <ArrowUpwardTwoTone />
                        </Tooltip>
                      ) : (
                        <div className="flex items-center providerlist-icon">
                          <SwapVertIcon />
                        </div>
                      )}
                    </button>
                  </div>
                </th> */}
                {user?.permissions?.includes('communities_dm.edit_community') && <th className="px-4 py-3">
                  <p className="m-0">Edit</p>
                </th>}
                {user?.permissions?.includes('communities_dm.delete_community') && <th className="px-4 py-3">
                  <p className="m-0">Delete</p>
                </th>}
              </tr>
            </thead>
            <tbody>
              {communities.length === 0 ? (
                <tr>
                  <td
                    colSpan={process.env.REACT_APP_ENV === "dev" ? 11 : 10}
                    className="py-6 text-lg text-center text-gray-400"
                  >
                    No records found
                  </td>
                </tr>
              ) : (
                communities
                  .filter(Boolean)
                  .sort((a, b) => handleSortNOP(a, b))
                  .sort((a, b) => handleSortName(a, b))
                  .map((community, index) => (
                    <tr
                      className={classNames(
                        "text-left text-gray-900 h-24 whitespace-nowrap",
                        index !== communities.length - 1
                          ? "border-b"
                          : "border-none"
                      )}
                      key={community.id}
                    >
                      <td className="px-4 py-3 text-left">
                        <button
                          onClick={() => user?.permissions?.includes('communities_dm.view_specific_community') && handleCommunityClick(community)}
                          className="flex flex-row gap-4 items-center"
                        >
                          <Avatar name={community.name} image={null} />
                          <p className="m-0 font-semibold underline">
                            {community.name}
                          </p>
                        </button>
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        {community.address}
                      </td>
                      <td className="px-4 py-3 text-left text-gray-700">
                        <span className="px-4 py-3 text-left text-gray-700">
                          {community.facility_type}
                        </span>
                      </td>
                      {process.env.REACT_APP_ENV === "dev" && (
                        <td className="gap-2 px-4 py-3 text-left text-gray-700">
                          <span
                            onClick={() => {
                              if (community.zips?.length > 0) {
                                setShowZipModal({ status: true, zips: community.zips });
                              }
                            }}
                            className={`${community.zips?.length > 0
                              ? 'text-primaryblue font-semibold underline cursor-pointer hover:text-blue-700 transition'
                              : 'text-gray-500 cursor-default'
                              }`}
                          >
                            {community?.zips?.length ?? 0}
                          </span>
                        </td>
                      )}
                      <td className="px-4 py-3 text-left text-gray-700">
                        {community.noOfPatients}
                      </td>
                      {/* <td className="px-4 py-3 text-left text-gray-700">
                        {row.noOfFacilities}
                      </td> */}
                      {user?.permissions?.includes('communities_dm.edit_community') && <td className="px-4 py-3 text-left text-gray-700">
                        <IconComponent
                          tooltip="Edit Community"
                          icon={"Edit_Icon"}
                          i={community}
                          onClick={() => onEdit(community)}
                        />
                      </td>}
                      {user?.permissions?.includes('communities_dm.delete_community') && <td className="px-4 py-3 text-left text-gray-700">
                        <IconComponent
                          tooltip="Delete Community"
                          icon={"Delete_Icon"}
                          i={community}
                          onClick={() => onDelete(community)}
                        />
                      </td>}
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {communityModalOpen && (
        <CommunityAddModal
          isOpen={communityModalOpen}
          edit={edit}
          clearInput={clearInput}
          onUpdate={onUpdateCommunity}
          onSave={saveCommunity}
          setOpen={setCommunityModalOpen}
          data={data}
          setData={setData}
        />
      )}
      {deleteModalOpen && (
        <CommunityDeleteModal
          isOpen={deleteModalOpen}
          clearInput={clearInput}
          onDeleteCommunity={onDeleteCommunity}
          setOpen={setDeleteModalOpen}
          data={data}
        />
      )}
      {zonesModalOpen && (
        <CommunityZoneEditModal
          open={zonesModalOpen}
          community={communityZonesData}
          setOpen={setZonesModalOpen}
          updateCommunityZones={updateCommunityZones}
        />
      )}
    </div>
  );
};

export default CommunityList;
